import { render, staticRenderFns } from "./FingerManager.vue?vue&type=template&id=1d23ada1"
import script from "./FingerManager.vue?vue&type=script&lang=js"
export * from "./FingerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports